import { Box, Flex } from 'reflexbox';

import { Avatar, Container, Paragraph } from '@treams/treams-ui';

export const CommentSkeleton = () => {
	return (
		<Flex>
			<Box flexGrow={0} flexShrink={0}>
				<Avatar.Skeleton size={32} />
			</Box>
			<Box flexGrow={1} flexShrink={1} ml={2}>
				<Paragraph.Skeleton lines={1} mb={2} ml={2} />
				<Container p={2}>
					<Paragraph.Skeleton />
				</Container>
			</Box>
		</Flex>
	);
};
